import { computed, watch, onMounted, unref } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';

/**
 * SuperTVGo: etiquetas do CONTATO — não da conversa.
 *
 * O card do ticket na lista mostrava `chat.labels` (etiqueta da CONVERSA),
 * que fica vazia sempre que um ticket novo é aberto — mesmo que o contato já
 * esteja classificado como `cliente`. Isso porque, desde a integração com a
 * Z-API, a classificação mora no contato de propósito: ela precisa sobreviver
 * ao atendente resolver o ticket (ver src/chatwoot/client.ts no repo da
 * SuperTVGo, `typebotDeveAtuar` / `ehLeadNovo`).
 *
 * Busca e cacheia por contactId, igual ao ContactLabels.vue da sidebar: o
 * mesmo contato aparecendo em duas conversas reaproveita a mesma busca via
 * `contactLabels/getContactLabels`.
 *
 * Devolve um array de TÍTULOS (strings), o mesmo formato que `chat.labels`
 * já tinha — os componentes de card (`CardLabels*.vue`) filtram esses títulos
 * contra `labels/getLabels` e resolvem cor/ícone sozinhos.
 */
export function useContactLabels(contactId) {
  const store = useStore();
  const contactLabelsGetter = useMapGetter('contactLabels/getContactLabels');

  const labels = computed(() => contactLabelsGetter.value(unref(contactId)));

  const fetch = id => {
    if (id) store.dispatch('contactLabels/get', id);
  };

  onMounted(() => fetch(unref(contactId)));

  watch(
    () => unref(contactId),
    (newId, oldId) => {
      if (newId && newId !== oldId) fetch(newId);
    }
  );

  return labels;
}
